export const UPDATE_MY_LIST = 'UPDATE_MY_LIST'
